import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mx-auto",attrs:{"max-width":"500"}},[_c(VToolbar,{attrs:{"color":"indigo","dark":""}},[_c(VAppBarNavIcon),_c(VToolbarTitle,[_vm._v("Inbox")]),_c(VSpacer),_c(VBtn,{attrs:{"icon":""}},[_c(VIcon,[_vm._v("mdi-magnify")])],1),_c(VBtn,{attrs:{"icon":""}},[_c(VIcon,[_vm._v("mdi-dots-vertical")])],1)],1),_c(VList,_vm._l((_vm.athletes),function(item){return _c(VListItem,{key:item.node.athleteId},[_c(VListItemIcon,[_c(VIcon,[_vm._v(" mdi-flag")])],1),_c(VListItemContent,[_c(VListItemTitle,{domProps:{"textContent":_vm._s(
            item.node.firstName +
              ' ' +
              item.node.birthDate +
              '(' +
              ((new Date().getMonth() >
              new Date(item.node.birthDate).getMonth()
                ? 1
                : 0) +
                new Date().getFullYear() -
                new Date(item.node.birthDate).getFullYear()) +
              ')'
          )}})],1)],1)}),1),_c(VSkeletonLoader,_vm._b({attrs:{"type":"card-avatar, article, actions"}},'v-skeleton-loader',_vm.attrs,false)),_c(VSkeletonLoader,_vm._b({attrs:{"type":"article, actions"}},'v-skeleton-loader',_vm.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }